export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceMailMagazineSetting: {
        serviceMailMagazineId: 1,
        serviceMailMagazineUuid: "mailmagazine001",
        mailMagazineName: "メルマガ001",
        mailMagazineAddress: "aaa@aaa.com",
        deliveryTypeMstId: 1,
        deliveryTypeMstUuid: "deliverytypemst001",
        noticeTypeMstId: 2,
        noticeTypeMstUuid: "noticeType002",
        keyWords: ["〇〇メルマガ"],
        keywordsQueryKbn: 1,
        exclusiveKeyWords: ["地域ニュース", "〇〇メルマガ"]
      }
    }
  }
}